import { ChartistModule } from 'ng-chartist';
import { ChartsModule } from 'ng2-charts';
import { Interceptor } from './insti/interceptor.module';
import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './demo-material-module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { SharedModule } from './shared/shared.module';
import { SpinnerComponent } from './shared/spinner.component';
import { MatCardModule, MatButtonModule, MatCheckboxModule, MatMenuModule, MatIconModule, DateAdapter, MAT_DATE_LOCALE } from '@angular/material';

import { CommonModule } from "@angular/common";
import {EditorModule} from 'primeng/editor';           
import { MenuItems } from './shared/menu-items/menu-items';
import { instiRoutehandle } from './insti/instiRoutehandle.module';
import {TableModule} from 'primeng/table';
import { MatFormFieldModule} from '@angular/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {MatSelectModule} from '@angular/material/select'; 
// import {NgxMaskModule, IConfig} from 'ngx-mask';
import { NgxCurrencyModule } from "ngx-currency";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PickListModule } from 'primeng/picklist';
// import {CalendarModule} from 'primeng/calendar';
import { CalendarModule } from 'primeng/components/calendar/calendar';
// import { FileSelectDirective, FileUploadModule } from 'ng2-file-upload';
import {DomSanitizer} from '@angular/platform-browser';
import { NgxLoadingModule } from 'ngx-loading';
import { AutoSelectComponent } from './gestao-condominio/componentes/auto-select/auto-select.component';

import { SelectAutocompleteModule } from 'mat-select-autocomplete';
import { HttpCancelService } from './insti/cancelPendingRequests/httpCancel.service';
import { ManageHttpInterceptor } from './insti/cancelPendingRequests/managehttp.interceptor';


@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppBlankComponent,
    AppSidebarComponent,
    // AutoSelectComponent
    // FileSelectDirective,
    // FileDropDirective,
    // FileUploader,
    // NgxImageGalleryModule
    
    
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    DemoMaterialModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    PerfectScrollbarModule,
    SharedModule,
    NgMultiSelectDropDownModule.forRoot(),
    // RouterModule.forRoot(GestaoCondominiosroutes, {onSameUrlNavigation: 'reload'}),
    RouterModule.forRoot(AppRoutes, {onSameUrlNavigation: 'reload'}),
    MatButtonModule, MatCheckboxModule, 
    MatMenuModule,
    MatIconModule,
    MatCardModule,
    EditorModule,
    Interceptor,
    instiRoutehandle,
    TableModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    SelectAutocompleteModule,
    MatSelectModule,
    // NgxMaskModule,
    NgxCurrencyModule,
    NgbModule,
    PickListModule,
    CalendarModule, 
    NgxLoadingModule.forRoot({}),
    ChartsModule,
    ChartistModule
    
  ],
  providers: [
  //   {
  //     provide: PERFECT_SCROLLBAR_CONFIG,
  //     useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
  //   }    
  HttpCancelService,
  { provide: HTTP_INTERCEPTORS, useClass: ManageHttpInterceptor, multi: true }

  ],
  bootstrap: [AppComponent]

})
export class AppModule {}

// export class MyModel {

//   values: string[];

// }

